exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-subscription-link-generator-card{border:1px solid #ebedf1;box-shadow:0 1px 2px rgba(38,110,255,0.05);border-radius:4px;width:283px;display:flex;flex-direction:column;padding:24px 20px;margin-top:20px}@media screen and (max-width: 991px){.ps-subscription-link-generator-card{width:100%}}.ps-subscription-link-generator-card_title{font-size:18px;font-weight:600;margin-bottom:15px}.ps-subscription-link-generator-card_subtitle{margin-bottom:20px}.ps-subscription-link-generator-card_input-box{display:flex;flex-direction:row;align-items:center}\n", ""]);

// exports
